module.exports = __webpack_public_path__ + "static/img/2.cb3cbb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/2.png
// module id = Az0A
// module chunks = 0